import HeroSlider from '@/components/HeroSlider';
import { useQuery } from '@tanstack/react-query';
import { useTitle } from 'react-use';
import { generateTitle } from '@/lib/text.utils';
import { fetcher } from '@/lib/queryClient';
import { useCssVariable } from '@/hooks/use-css-variable';
import { CategoriesWithBanners } from '@/components/categories/categories-with-banners';
import type { CategoriesGames } from '@/types/category';
import { NewGamesCarousel } from '@/components/NewGamesCarousel';
import { HeroNavButtons } from '@/components/hero-nav-buttons';

export default function Home() {
  useCssVariable('--main-container-max-width', '100%', { removeOnUnmount: true });

  useTitle(generateTitle());

  const { data: categoriesGames = [] } = useQuery<CategoriesGames[]>({
    queryKey: ['api/games/categories'],
    queryFn: fetcher,
  });

  return (
    <main className="main-container">
      <section>
        <HeroNavButtons />
      </section>

      <section className="flex gap-4 flex-col xl:flex-row">
        <div className="w-full">
          <HeroSlider />
        </div>
      </section>
      <section className="flex flex-col gap-8 md:gap-14">
        <NewGamesCarousel />
        <CategoriesWithBanners categories={categoriesGames} />
      </section>
    </main>
  );
}
